import React from "react"
import autobind from "class-autobind"
import { Toggle, TextField, Paper } from "material-ui"
import strings from "../../localization/strings"
import { ELanguage, IQuestionIntroduction } from "../../models"
import _ from "lodash"
import ExpandLess from "material-ui/svg-icons/navigation/expand-less"
import ExpandMore from "material-ui/svg-icons/navigation/expand-more"
interface IProps {
    punchIn: boolean
    readonly: boolean
    selectedLanguages: ELanguage[]
    toggleTitle: string
    allowIntro: boolean
    introductions: IQuestionIntroduction[]
    handleChangeAllowIntro(allow: boolean): void
    handleChangeIntro(introductions: IQuestionIntroduction[]): void
}
interface IState {
    expand: boolean
}
export default class QuestionIntroduction extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expand: false
        }
        autobind(this)
    }

    render() {
        return (
            <Paper style={{ marginTop: 15, padding: 15, position: "relative" }}>
                <Toggle
                    data-intercom-target={`Questions-Toggle-${this.props.toggleTitle}`}
                    label={this.props.toggleTitle}
                    style={{ width: 350 }}
                    onToggle={(e, allowIntro) => this.props.handleChangeAllowIntro(allowIntro)}
                    toggled={this.props.allowIntro}
                    disabled={this.props.readonly}
                />
                {this.props.allowIntro &&
                    <div
                        data-intercom-target={`Questions-Expand-${this.props.toggleTitle}`}
                        style={{ position: "absolute", right: 15, top: 15 }}
                        onClick={() => this.setState({ expand: !this.state.expand })}
                    >
                        {this.state.expand ? <ExpandLess /> : <ExpandMore />}
                    </div>
                }
                {this.props.allowIntro && this.state.expand &&
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: -15, overflow: "auto" }}>
                        {this.props.selectedLanguages.map(language =>
                            <QuestionIntroductionItem
                                key={language}
                                punchIn={this.props.punchIn}
                                readonly={this.props.readonly}
                                selectedLanguages={this.props.selectedLanguages}
                                language={language}
                                introduction={this.props.introductions.find(i => i.Language === language)}
                                handleAdd={introduction => {
                                    const introductions = _.cloneDeep(this.props.introductions)
                                    introductions.push(introduction)
                                    introductions.sort((a, b) => {
                                        if (a.Language === b.Language) return 0
                                        if (a.Language < b.Language) return -1
                                        if (a.Language > b.Language) return 1
                                    })
                                    this.props.handleChangeIntro(introductions)
                                }}
                                handleUpdate={introduction => {
                                    const introductions = _.cloneDeep(this.props.introductions)
                                    introductions[introductions.findIndex(i => i.Language === introduction.Language)] = introduction
                                    this.props.handleChangeIntro(introductions)
                                }}
                                handleDelete={() => {
                                    let introductions = _.cloneDeep(this.props.introductions)
                                    introductions = introductions.filter(i => i.Language !== language)
                                    this.props.handleChangeIntro(introductions)
                                }}
                            />
                        )}
                    </div>

                }
            </Paper>
        )
    }
}

interface IIntroductionProps {
    punchIn: boolean
    readonly: boolean
    selectedLanguages: ELanguage[]
    language: ELanguage
    introduction: IQuestionIntroduction
    handleAdd(introduction: IQuestionIntroduction): void
    handleUpdate(introduction: IQuestionIntroduction): void
    handleDelete(): void
}
interface IIntroductionState {
    title: string
    errorTitle: string
    btnLabel: string
    errorBtnLabel: string
    body: string
    errorBody: string
}

class QuestionIntroductionItem extends React.Component<IIntroductionProps, IIntroductionState> {
    constructor(props: IIntroductionProps) {
        super(props)
        this.state = {
            title: props.introduction && props.introduction.Title || "",
            errorTitle: "",
            btnLabel: props.introduction && props.introduction.BtnLabel || "",
            errorBtnLabel: "",
            body: props.introduction && props.introduction.Body || "",
            errorBody: "",
        }
        autobind(this)
    }

    handleChange() {
        if (this.checkValidate()) {
            let introduction = _.cloneDeep(this.props.introduction)
            if (!introduction) {
                introduction = {
                    PunchIn: this.props.punchIn,
                    Body: null,
                    Language: this.props.language,
                    Title: null,
                    BtnLabel: null,
                }
            }
            introduction.Body = this.state.body.trim()
            introduction.BtnLabel = this.state.btnLabel.trim()
            introduction.Title = this.state.title.trim()

            this.props.introduction ?
                this.props.handleUpdate(introduction) :
                this.props.handleAdd(introduction)
        }
        else {
            this.props.handleDelete()
        }
    }

    checkValidate() {
        let isValid = true

        if (!this.state.title.trim()) {
            this.setState({ errorTitle: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (this.state.title.trim().length > 25) {
                this.setState({ errorTitle: strings.formatString(strings.max_x_chars, 25) as string })
                isValid = false
            }
            else {
                this.setState({ errorTitle: "" })
            }
        }

        if (!this.state.btnLabel.trim()) {
            this.setState({ errorBtnLabel: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (this.state.btnLabel.trim().length > 15) {
                this.setState({ errorBtnLabel: strings.formatString(strings.max_x_chars, 15) as string })
                isValid = false
            }
            else {
                this.setState({ errorBtnLabel: "" })
            }
        }

        if (!this.state.body.trim()) {
            this.setState({ errorBody: strings.This_field_is_required })
            isValid = false
        }
        else {
            this.setState({ errorBody: "" })
        }

        return isValid
    }

    render() {
        return (
            <div>
                <div style={{ display: "flex" }}>
                    <TextField
                        data-intercom-target={"QuestionIntorduction-Entry-Title"}
                        name="title"
                        disabled={this.props.readonly}
                        floatingLabelText={this.props.selectedLanguages.length === 1 ?
                            strings.Title :
                            strings.formatString(strings.Title_langX, ELanguage[this.props.language])
                        }
                        style={{ flex: this.props.selectedLanguages.length > 1 && 1, width: 175, marginRight: 20 }}
                        value={this.state.title}
                        onChange={(e, value) => this.setState({ title: value }, () => this.handleChange())}
                        errorText={this.state.errorTitle}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                    />
                    <TextField
                        data-intercom-target={"QuestionIntorduction-Entry-BtnLabel"}
                        name="btnLabel"
                        disabled={this.props.readonly}
                        floatingLabelText={this.props.selectedLanguages.length === 1 ?
                            strings.Button_Label :
                            strings.formatString(strings.Button_Label_langX, ELanguage[this.props.language])
                        }
                        style={{ flex: this.props.selectedLanguages.length > 1 && 1, width: 175, marginRight: 20 }}
                        value={this.state.btnLabel}
                        onChange={(e, value) => this.setState({ btnLabel: value }, () => this.handleChange())}
                        errorText={this.state.errorBtnLabel}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                    />
                </div>
                <TextField
                    data-intercom-target={"QuestionIntorduction-Entry-Message"}
                    name="body"
                    multiLine
                    rows={2}
                    rowsMax={2}
                    disabled={this.props.readonly}
                    floatingLabelText={this.props.selectedLanguages.length === 1 ?
                        strings.Introduction_message :
                        strings.formatString(strings.Introduction_message_Language_x, ELanguage[this.props.language])
                    }
                    style={{ flex: this.props.selectedLanguages.length > 1 && 1, width: 400, marginRight: 20 }}
                    value={this.state.body}
                    onChange={(e, value) => this.setState({ body: value }, () => this.handleChange())}
                    errorText={this.state.errorBody}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                />
            </div>
        )
    }
}